import React from 'react';

function BranchCheck({ color = '#335B70', secondaryColor = '#D4D8DC', ...props }) {
    return (
        <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
            <path
                d="M12.998 13.2c-3.341 0-4.435 1.316-4.793 2.184 1.064.448 1.81 1.482 1.81 2.691C10.015 19.694 8.682 21 7.03 21c-1.65 0-2.983-1.306-2.983-2.925a2.92 2.92 0 0 1 1.989-2.76v-8.13a2.92 2.92 0 0 1-1.99-2.76C4.048 2.807 5.38 1.5 7.032 1.5s2.984 1.307 2.984 2.925a2.92 2.92 0 0 1-1.99 2.76v5.157c.876-.634 2.149-1.092 3.979-1.092 2.655 0 3.54-1.306 3.829-2.174-1.074-.439-1.84-1.482-1.84-2.701 0-1.619 1.332-2.925 2.983-2.925s2.984 1.306 2.984 2.925a2.913 2.913 0 0 1-2.079 2.789c-.258 1.394-1.223 4.036-4.883 4.036Zm-5.967 3.9a.988.988 0 0 0-.994.975c0 .536.447.975.994.975a.988.988 0 0 0 .995-.975.988.988 0 0 0-.995-.975Zm0-13.65a.988.988 0 0 0-.994.975c0 .536.447.975.994.975a.988.988 0 0 0 .995-.975.988.988 0 0 0-.995-.975Zm9.945 1.95a.988.988 0 0 0-.994.975c0 .536.447.975.994.975a.988.988 0 0 0 .995-.975.988.988 0 0 0-.995-.975Z"
                fill={color}
            />
            <path
                d="m13.993 17.256 2.735 2.925 4.724-4.631-1.154-1.375-3.57 3.5-1.581-1.55-1.154 1.131Z"
                fill={secondaryColor}
            />
        </svg>
    );
}

export default BranchCheck;
